import { render, staticRenderFns } from "./MPOnboard.vue?vue&type=template&id=351c6859&"
import script from "./MPOnboard.vue?vue&type=script&lang=js&"
export * from "./MPOnboard.vue?vue&type=script&lang=js&"
import style0 from "./MPOnboard.vue?vue&type=style&index=0&id=351c6859&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports